document.addEventListener("DOMContentLoaded", function () {
  const swiperSlider = new Swiper(".swiper", {
    loop: true,
    effect: "slide",
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
});
